import React, { Component } from 'react';
import { SERVER_CONFIG } from '../../../Config';

class WidgetRenderer extends Component {
    // static proptypes = {
    //     children: PropTypes.func.isRequired
    // }

    state = {
        mediaData: null,
        isLoaded: false
    }

    constructor(props) {
        super(props);
        this.state = { rand: Math.random() };
    }

    componentDidMount() {
        this.updateDataFromProps(this.props)
        // this.handleNewInstanceData(this.props.data)
    }

    componentWillReceiveProps(props) {
        this.updateDataFromProps(props);
    }

    updateDataFromProps = (props) => {

        if (!props)
            return

        const { data = null } = props;

        this.setState({ mediaData: data });
    }

    componentDidUpdate(prevProps) {
        console.log("componentDidUpdate")
        if (this.props.data !== prevProps.data) {
            this.handleNewInstanceData(this.props.data)
        }
    }

    handleNewInstanceData = (mediaData) => {
        console.log("*** handleNewInstanceData " + JSON.stringify(mediaData))
        if (mediaData) {
            this.applyInstanceSetting(mediaData)
        }
        else {
            this.applyInstanceSetting()
        }
    }

    appleSettings = (settings, target = "") => {
        const iframeWin = document.getElementById(`widget-iframe-${target}`)

        // const { mediaData = null } = this.state;

        // if (!mediaData) {
        //     return null;
        // }

        if (iframeWin)
            iframeWin.contentWindow.postMessage(JSON.stringify({ action: "on_setting_update", target: target, param: settings }), "*")
    }


    applyInstanceSetting = (mediaData) => {
        if (!mediaData) {
            this.instanceName = "";
            this.widgetSettings = {}
            this.appleSettings(this.widgetSettings)
            return;
        }

        this.instanceName = mediaData.MediaName
        this.widgetSettings = JSON.parse(mediaData.Setting)
        this.appleSettings(this.widgetSettings, mediaData.MediaID)
    }

    onIFrameLoaded = () => {
        console.log("iframe loaded")

        const { data } = this.props

        if (data) {
            this.applyInstanceSetting(data)
            this.setState({ isLoaded: true })
        }
        else {
            // this.setState{ widgetInstanceData: undefined }
        }
        // this.onSettingsUpdated()
    }
    componentWillUnmount() {
        window.removeEventListener("message", this.receivePoseMessageHandler)
    }

    render() {
        const { mediaData = null } = this.state;

        if (!mediaData) {
            return null;
        }

        const { FileType } = mediaData;

        console.log("mediaData mediaData mediaData mediaData " + mediaData.MediaID)
        return (
            <iframe onLoad={this.onIFrameLoaded} id={`widget-iframe-${mediaData.MediaID}`} frameBorder="none" style={{ height: "100%", width: "100%", opacity: this.state.isLoaded ? 1 : 0 }} src={`${SERVER_CONFIG.SERVER_URI}widgets/${FileType}/preview?id=${mediaData.MediaID}&random=${this.state.rand}`}></iframe>
        )
    }
}

export default WidgetRenderer